import config from './config.js'

export default {

  list: function(ctrl,start,count,search,status,cb) {
    var url = config.baseUrl + 'rest/giftcards/data/?start=' + encodeURIComponent(start) + '&count=' + encodeURIComponent(count);
    if (search) {
      url += '&search=' + encodeURIComponent(search);
    }
    if (status !== false && status >= 0) {
      url += '&status=' + status;
    }
    config.get(ctrl,url,'Aktion Codes laden',cb);
  },

  save: function(ctrl,data,sync,cb) {
    config.post(ctrl,config.baseUrl + 'rest/giftcards/data/' + (sync ? '?sync=1' : ''),'Aktions Code speichern',JSON.stringify(data),cb);
  },

  load: function(ctrl,mapid,cb) {
    config.get(ctrl,config.baseUrl + 'rest/giftcards/data/' + encodeURIComponent(mapid),'Aktions Code laden',cb);
  },

  usageStat: function(ctrl,mapid,start,end,cb) {
    var sv = start.toISOString().substring(0,10);
    var ev = end.toISOString().substring(0,10);
    var url  = config.baseUrl + 'rest/giftcards/usage/' + encodeURIComponent(mapid) + '?start=' + sv + '&end=' + ev;
    config.get(ctrl, url, 'Aktion Codes Statistik laden',cb);
  }

}
